import {createStore} from 'vuex';
import {language} from './language.store';
import {auth} from './auth.store';
import {testdrive} from './testdrive.store';
import {customer} from './customer.store';
import {company} from './company.store';
import {project} from './project.store';
import {vehicle} from './vehicle.store';
import {product} from './product.store';
import store from '@/store';
import {ElNotification} from 'element-plus';

export default createStore({
    state: {},
    notifications: {
        showSomething: {
            title: 'Something happened',
            message: 'See console for details',
            type: 'error'
        }
    },
    mutations: {
        reset(state) {
            testdrive.state.items = [];
            testdrive.state.statuses = [];

            customer.state.items = [];

            company.state.items = [];

            project.state.items = [];

            vehicle.state.orders = [];
            vehicle.state.vehicles = [];
            vehicle.state.vehiclesSearch = {input: '', view: 2, companyID: 0};
            vehicle.state.statuses = [];

            vehicle.state.warrantyClaims = [];
            vehicle.state.warrantyClaimSearch = {
                input: '',
                companyID: 0,
                from: '',
                to: '',
                statuses: ['New', 'Returned', 'Approved', 'Submitted']
            };

            vehicle.state.maintenances = [];
            vehicle.state.maintenanceSearch = {input: '', companyID: 0, from: '', to: '', statuses: ['New']};

            vehicle.state.serviceReports = [];
            vehicle.state.serviceReportSearch = {
                input: '',
                companyID: 0,
                from: '',
                to: '',
                statuses: ['New', 'Returned', 'Submitted']
            };

            vehicle.state.serviceReminders = [];
            vehicle.state.serviceReminderSearch = {input: '', companyID: 0};

            product.state.products = [];
            product.state.stockOrders = [];
            product.state.stockInvoices = [];
            product.state.stockTakings = [];
            product.state.productOrders = [];
            product.state.productInvoices = [];

        },
        error: (state, err) => {
            //console.log('store error - ', err);
            let msg = null;
            if (err.name === 'AxiosError') {
                msg = err.message + (err.request && err.request.responseURL ? '<br />' + err.request.responseURL : '');
            } else {
                if (err.response) {
                    msg = err.result ? err.result : err.response.data ? err.response.data : 'Error';
                    console.log('Error Response', err, msg);
                } else if (err.request) {
                    msg = err.result ? err.result : err.message ? err.message : 'Error';
                    console.log('Error Request', err, msg);
                } else {
                    msg = err.result ? err.result : err.message ? err.message : 'Error';
                    console.log('Error Else', err, msg);
                }
            }
            ElNotification.error({
                title: err.title ? err.title : err.name === 'AxiosError' ? 'Error' : err.name,
                message: msg,
                showClose: true,
                duration: 3000,
                dangerouslyUseHTMLString: true,
                type: 'error',
            });
        },
    },
    actions: {
        reset({commit}) {
            commit('reset');
        },
        error({commit}, data) {
            commit('error', data);
        },
    },
    modules: {
        language,
        auth,
        testdrive,
        customer,
        company,
        project,
        vehicle,
        product,
    },
    getters: {
        user: state => {
            const user = state.auth.user;
            return user ? user : [];
        },
        userCompany: state => {
            const user = state.auth.user;
            if (!user) return [];
            const companyID = user.companyID;
            if (companyID > 0) {
                return user.companies.find(company => company.companyID === user.companyID);
            } else {
                if (user.companies && user.companies.length > 1) {
                    ////return user.companies ? (user.companies[0] ? user.companies[0] : {}) : {};

                    return {companyID: 0, companyName: 'ALL'}
                } else {
                    return user.companies ? (user.companies[0] ? user.companies[0] : {}) : {};
                }
            }
        },
        userCompanies: state => {
            const user = state.auth.user;
            return user ? user.companies ? user.companies : [] : [];
        },
        userPermissions: state => {
            const user = state.auth.user;
            return user ? user.permissions ? user.permissions : [] : [];
        },
        pagePermissions: state => {
            const user = state.auth.user;
            return user ? user.pagePermissions ? user.pagePermissions : [] : [];
        },
        urlPermissions: (state) => (url) => {
            const user = state.auth.user;
            const permissions = user ? user.permissions ? user.permissions : [] : [];

            function deepSearch(object, key, predicate) {
                if (object.hasOwnProperty(key) && predicate(key, object[key]) === true) return object;
                for (let i = 0; i < Object.keys(object).length; i++) {
                    let value = object[Object.keys(object)[i]];
                    if (typeof value === "object" && value != null) {
                        let o = deepSearch(object[Object.keys(object)[i]], key, predicate);
                        if (o != null) return o;
                    }
                }
                return null;
            }

            let result = deepSearch(permissions, 'url', (k, v) => v === url);
            return result && result.permissions ? result.permissions : [];
        },
        hasPermission: (state) => (permission) => {
            const user = state.auth.user;
            const permissions = user ? user.pagePermissions ? user.pagePermissions : [] : [];
            const found = permissions.findIndex(element => element.hash === permission);
            return (found > -1);
        },
        userNotifications: state => {
            const user = state.auth.user;
            return user ? user.notifications ? user.notifications : [] : [];
        },
        userLanguage: state => {
            return state.language.language ? state.language.language : 'en';
        },
        languages: state => {
            const languages = state.language.languages;
            return languages ? languages : [];
        },
    },
    strict: process.env.NODE_ENV !== 'production'
})
